import { useCallback } from 'react'
import { DepositConfig, WithdrawConfig } from '@/types'

// Export translation hooks
export { useTranslation, useTranslationWithLocale } from './useTranslation'

// Global event system (will be implemented later)
const globalEventEmitter = {
  emit: (event: string, data: any) => {
    // Event emitted
  },
}

export const useDeposit = () => {
  const openDeposit = useCallback((config: DepositConfig) => {
    globalEventEmitter.emit('deposit:open', config)
  }, [])

  return { openDeposit }
}

export const useWithdraw = () => {
  const openWithdraw = useCallback((config: WithdrawConfig) => {
    globalEventEmitter.emit('withdraw:open', config)
  }, [])

  return { openWithdraw }
}

export * from './usePoolBalance'
